export default __webpack_public_path__ + "static/media/2008-IMcover.56dbdbdf.jpg";